// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zvDX","largestCol":"styles_largestCol__1OwYH","smallestCol":"styles_smallestCol__--4I8"};